module.exports = __webpack_public_path__ + "img/apple-icon-120x120.472903b5.png";